import { render, staticRenderFns } from "./GestionCapacitacion.vue?vue&type=template&id=5c61a3f2"
import script from "./GestionCapacitacion.vue?vue&type=script&lang=js"
export * from "./GestionCapacitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports